import { render, staticRenderFns } from "./PlayerDetail.vue?vue&type=template&id=e13c3668&scoped=true"
import script from "./PlayerDetail.vue?vue&type=script&lang=js"
export * from "./PlayerDetail.vue?vue&type=script&lang=js"
import style0 from "./PlayerDetail.vue?vue&type=style&index=0&id=e13c3668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13c3668",
  null
  
)

export default component.exports